/* ------------------------------------------------------------------------------------------------------------------
   JWL CART — STUDIO LIGHT: free-shipping progress track
   ------------------------------------------------------------------------------------------------------------------
   Progressively enhances the theme's existing <free-shipping-bar> element (snippets/free-shipping-bar.liquid,
   customElements.define("free-shipping-bar", ...) in theme.js) with a slim progress bar. Reads the same threshold /
   total-price attributes the theme's own component already keeps up to date — no cart fetching or event listening
   of our own for that part.

   A single element-attribute observer isn't enough here: the cart drawer replaces its entire body via
   replaceChildren() whenever the cart changes (CartDrawer.replaceContent_fn in theme.js), which throws away
   whichever <free-shipping-bar> node we'd already enhanced. So this watches document.body for any DOM change and
   re-scans, rather than trying to track one specific element's lifetime. ensureTrack() is idempotent (checks for
   an existing track before inserting one), so re-scanning on every mutation is safe and cheap given how few
   free-shipping-bar elements exist on a page.

   Builds two rows inside <free-shipping-bar>: a "jwl-shipping-message" row holding the truck icon next to the
   theme's own message text, and a separate "jwl-shipping-track" row below it for the progress line. The message
   row must stay FIRST in DOM order — see the comment on .jwl-shipping-message in jwl-cart-studio-light.css for
   why (the theme's own FreeShippingBar class finds its text target via `querySelector('span')`, the first <span>
   in the tree, so the track's fill <span> must never end up ahead of the message's placeholder <span>).
   ------------------------------------------------------------------------------------------------------------------ */
(function () {
  function ensureParts(el) {
    var message = el.querySelector('.jwl-shipping-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'jwl-shipping-message';
      el.insertBefore(message, el.firstChild);
    }

    /* Icon and the theme's placeholder <span> both start as direct children of <free-shipping-bar> on first
       paint (see free-shipping-bar.liquid); move them into the message row, icon first. */
    var icon = el.querySelector('.jwl-shipping-row__icon');
    if (icon && icon.parentElement !== message) {
      message.insertBefore(icon, message.firstChild);
    }

    var placeholder = el.querySelector('.text-subdued');
    if (placeholder && placeholder.parentElement !== message) {
      message.appendChild(placeholder);
    }

    var track = el.querySelector('.jwl-shipping-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'jwl-shipping-track';
      track.appendChild(document.createElement('span'));
      el.insertBefore(track, message.nextSibling);
    }

    /* Track-end icon, same idea as the message-row icon above: starts as a direct child of <free-shipping-bar>
       on first paint (see free-shipping-bar.liquid), gets moved into the track once. Appended, not inserted
       first — position is handled entirely by CSS (absolute, anchored to the track's right edge), so DOM order
       here doesn't matter, unlike the message row's icon-before-placeholder-span requirement above. */
    var trackIcon = el.querySelector('.jwl-shipping-track__icon');
    if (trackIcon && trackIcon.parentElement !== track) {
      track.appendChild(trackIcon);
    }

    return track;
  }

  function update(el) {
    var track = ensureParts(el);
    var fill = track.querySelector('span');
    var threshold = parseFloat(el.getAttribute('threshold')) || 0;
    var total = parseFloat(el.getAttribute('total-price')) || 0;
    var qualified = threshold > 0 && total >= threshold;
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
    fill.style.width = pct + '%';
    track.classList.toggle('jwl-shipping-track--qualified', qualified);
  }

  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(update);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['total-price', 'threshold'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
